(function () {
  function autoSelectAvailableVariant() {
    const variantPicker = document.querySelector('variant-picker');
    if (!variantPicker) return;

    const fieldsets = variantPicker.querySelectorAll('fieldset');
    if (fieldsets.length < 1) return;

    const sizeFieldset = fieldsets[0];
    const allSizes = Array.from(sizeFieldset.querySelectorAll('input'));

    const checkedAvailable = allSizes.find(
      (input) => input.checked && input.dataset.optionAvailable === 'true'
    );
    if (checkedAvailable) return;

    const firstAvailable = allSizes.find(
      (input) => input.dataset.optionAvailable === 'true'
    );
    if (firstAvailable) {
      firstAvailable.checked = true;
      firstAvailable.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  // Horizon nutzt history.replaceState beim Farbwechsel – wir patchen es ab
  const originalReplaceState = history.replaceState.bind(history);
  history.replaceState = function (state, title, url) {
    const oldPath = location.pathname;
    originalReplaceState(state, title, url);
    const newPath = location.pathname;

    if (newPath !== oldPath) {
      // Pfad hat sich geändert = Farbwechsel → nach kurzem Delay prüfen
      clearTimeout(window.__autoSelectTimer);
      window.__autoSelectTimer = setTimeout(autoSelectAvailableVariant, 100);
    }
  };

  document.addEventListener('DOMContentLoaded', autoSelectAvailableVariant);
})();
